export const TravelSource = {
    CALC: 'CALC',
    ADMIN: 'ADMIN',
    API: 'API',
};
/** Значення в порядку оголошення в схемі. */
export const TRAVEL_SOURCE_VALUES = ['CALC', 'ADMIN', 'API'];
export const TRAVEL_SOURCE_LABELS = {
    CALC: 'Розраховано з координат',
    ADMIN: 'Задано вручну',
    API: 'Сервіс маршрутів',
};
export const TRAVEL_SOURCE_TONES = {
    CALC: 'neutral',
    ADMIN: 'info',
    API: 'neutral',
};
//# sourceMappingURL=travel-source.js.map